import * as React from "react";
import type { SVGProps } from "react";
const SvgCard02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 9.3h18M6.6 13.5h3M4.8 5.1h14.4a2.4 2.4 0 0 1 2.4 2.4V16.5a2.4 2.4 0 0 1-2.4 2.399H4.8a2.4 2.4 0 0 1-2.4-2.4v-9a2.4 2.4 0 0 1 2.4-2.4"
    />
  </svg>
);
export default SvgCard02;
